<template>
  <div class="tags-view-container">
    <div class="tags-view-wrapper">
      <router-link
        v-for="tag in visitedViews"
        :key="tag.path"
        :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }"
        :class="isActive(tag) ? 'active' : ''"
        class="tags-view-item"
        @contextmenu.prevent.native="openMenu(tag, $event)"
      >
        {{ tag.title }}
        <span
          v-if="!tag.meta?.affix"
          class="el-icon-close"
          @click.prevent.stop="closeTag(tag)"
        ></span>
      </router-link>
    </div>
    <ul v-show="visible" :style="{ left: left + 'px', top: top + 'px' }" class="contextmenu">
      <li @click="closeOtherTags">关闭其他</li>
      <li @click="closeAllTags">关闭所有</li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TagsView',
  data() {
    return {
      visible: false,
      top: 0,
      left: 0,
      selectedTag: null
    }
  },
  computed: {
    ...mapGetters(['visitedViews'])
  },
  watch: {
    $route() {
      this.addTag()
    },
    visible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  mounted() {
    this.addTag()
  },
  methods: {
    isActive(tag) {
      return tag.path === this.$route.path
    },
    addTag() {
      const { name, path, meta, query, fullPath } = this.$route
      if (name && path !== '/login' && path !== '/404') {
        this.$store.dispatch('addView', { name, path, meta, query, fullPath })
      }
    },
    closeTag(tag) {
      this.$store.dispatch('delView', tag).then(views => {
        if (this.isActive(tag)) {
          const latestView = views.slice(-1)[0]
          if (latestView) {
            this.$router.push(latestView.fullPath)
          } else {
            this.$router.push('/')
          }
        }
      })
    },
    openMenu(tag, e) {
      this.left = e.clientX
      this.top = e.clientY
      this.visible = true
      this.selectedTag = tag
    },
    closeMenu() {
      this.visible = false
    },
    closeOtherTags() {
      this.$store.dispatch('delOtherViews', this.selectedTag)
      if (this.selectedTag.path !== this.$route.path) {
        this.$router.push(this.selectedTag.fullPath)
      }
    },
    closeAllTags() {
      this.$store.dispatch('delAllViews')
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.tags-view-container {
  height: 34px;
  background: #fff;
  border-bottom: 1px solid #d8dce5;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12);
}
.tags-view-wrapper {
  display: flex;
  padding: 4px 10px;
  overflow-x: auto;
}
.tags-view-item {
  display: inline-flex;
  align-items: center;
  padding: 0 10px;
  height: 26px;
  line-height: 26px;
  border: 1px solid #d8dce5;
  margin-right: 5px;
  font-size: 12px;
  color: #495060;
  background: #fff;
  text-decoration: none;
  border-radius: 3px;
}
.tags-view-item.active {
  background-color: #409EFF;
  color: #fff;
  border-color: #409EFF;
}
.tags-view-item .el-icon-close {
  margin-left: 5px;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  text-align: center;
  line-height: 16px;
}
.tags-view-item .el-icon-close:hover {
  background-color: #b4bccc;
  color: #fff;
}
.tags-view-item.active .el-icon-close:hover {
  background-color: #fff;
  color: #409EFF;
}
.contextmenu {
  position: fixed;
  margin: 0;
  padding: 5px 0;
  background: #fff;
  z-index: 3000;
  list-style: none;
  border-radius: 4px;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
}
.contextmenu li {
  padding: 7px 16px;
  cursor: pointer;
}
.contextmenu li:hover {
  background: #eee;
}
</style>
